import { createContext, useContext, useReducer } from "react";

const formReducer = (state, action) => {
  switch (action.type) {
    //Controllo che setta i dati dell'API
    case "SET_DATA_API":
      return {
        ...state,
        ...action.payload,
      };
    //Controllo per gli Accordi
    case "set_accordo":
      return {
        ...state,
        accordo: {
          ...state.accordo,
          ...action.payload,
        },
      };
    //Controllo per le Condizioni
    case "set_condizioni":
      return {
        ...state,
        condizioni: { ...state.condizioni, dataset: action.payload },
      };
    //Controllo per gli Utenti delle Agenzie
    case "set_utenti":
      return {
        ...state,
        agenzie: state.agenzie.map((el) =>
          el.id === action.id ? { ...el, ...action.payload } : el
        ),
      };

    //Controllo per le Garanzie
    case "set_garanzie":
      return {
        ...state,
        garanzie: state.garanzie.map((el) =>
          el.idGaranzia === action.id ? { ...el, ...action.payload } : el
        ),
      };
    case "set_new_garanzia":
      return {
        ...state,
        garanzie: [...state.garanzie, action.payload.garanzia],
      };

    //Controllo per le Impostazioni
    case "set_impostazioni":
      return {
        ...state,
        impostazioni: {
          ...state.impostazioni,
          ...action.payload,
        },
      };

    //Controlli Agenzie e Imposta tutti i dati uguali nelle agenzie
    case "set_agenzie":
      return {
        ...state,
        agenzie: state.agenzie.map((el) =>
          el.id === action.id ? { ...el, ...action.payload } : el
        ),
      };
    case "set_all_agenzie_stato":
      return {
        ...state,
        agenzie: state.agenzie.map((agenzia) => ({
          ...agenzia,
          abilitato: action.payload, // Aggiorna stato (abilitato) per tutte le righe
        })),
      };
    case "set_all_agenzie_visibile":
      return {
        ...state,
        agenzie: state.agenzie.map((agenzia) => ({
          ...agenzia,
          visibile: action.payload, // Aggiorna visibile per tutte le righe
        })),
      };
    case "set_all_agenzie_acquistabile":
      if (action.controllo === "acquistabile") {
        return {
          ...state,
          agenzie: state.agenzie.map((agenzia) => ({
            ...agenzia,
            [action.controllo]: action.payload,
            visibile: agenzia.visibile === 0 && action.payload === 0 ? 0 : 1, // Aggiorna acquistabile per tutte le righe
          })),
        };
      }
    case "set_all_agenzie_tipoFee":
      return {
        ...state,
        agenzie: state.agenzie.map((agenzia) => ({
          ...agenzia,
          tipoFee: action.payload, // Update the "abilitato" field for all rows
        })),
      };
    case "set_all_agenzie_fee":
      return {
        ...state,
        agenzie: state.agenzie.map((agenzia) => ({
          ...agenzia,
          fee: action.payload, // Update the "abilitato" field for all rows
        })),
      };

    //Case for documenti
    case "set_documenti":
      return {
        ...state,
        documenti: state.documenti.some((el) => el.idUidDocumento === action.id)
          ? state.documenti.map((el) =>
              el.idUidDocumento === action.id
                ? { ...el, ...action.payload }
                : el
            )
          : [
              ...state.documenti,
              { idUidDocumento: action.id, ...action.payload },
            ],
      };
  }
};

const ContextAccordo = createContext(null);

const initialData = {
  accordo: {},
  condizioni: [],
  documenti: [],
  agenzie: [],
  garanzie: [],
  impostazioni: {},
};

export const FormAccordoProvider = ({ children }) => {
  const [formState, dispatch] = useReducer(formReducer, initialData);

  return (
    <ContextAccordo.Provider value={{ formState, dispatch }}>
      {children}
    </ContextAccordo.Provider>
  );
};

// Hook to use form context
export const useFormAccordo = () => {
  const context = useContext(ContextAccordo);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};
